<!-- eslint-disable -->
<template>
  <div class="contenu">
    <h1 class="titre">{{ $t('title') }}</h1>

    <div style="margin-top: 55px;">
      <div class="temps">
        <h2 style="font-weight: 600;">{{ $t('countdown') }}</h2>
        <div class="countdown">
          <div class="countdown-item">
            <span>{{ days }}</span>
            <p>{{ $t('days') }}</p>
          </div>
          <div class="countdown-item">
            <span>{{ hours }}</span>
            <p>{{ $t('hours') }}</p>
          </div>
          <div class="countdown-item">
            <span>{{ minutes }}</span>
            <p>{{ $t('minutes') }}</p>
          </div>
          <div class="countdown-item">
            <span>{{ seconds }}</span>
            <p>{{ $t('seconds') }}</p>
          </div>
        </div>
      </div>

      <img class="fond" src="../assets/img/Photo_fond_ecran.jpg" alt="Main image">
    </div>

    <div class="message">
      <p>
        {{ $t('idea') }}
      </p>
      <p>
        {{ $t('task') }}
      </p>
    </div>

    <div class="location">
      <h3 style="font-weight: 600;">{{ $t('location') }}</h3>
      <div class="infos">
        <p><a href="https://www.circuitstecroix.ca/cms">{{ $t('circuit') }}</a></p>
        <p>{{ $t('address') }}</p>
        <p>{{ $t('date') }}</p>
      </div>
    </div>

    <img class="timeline" src="../assets/img/CSQ24_Timeline.png" alt="timeline">

    <h2 style="font-weight: 600; text-align: left; font-family: Lato; width: 75%; align-items : center; text-align : left; margin: auto;">{{ $t('drone') }}</h2>
    <div class="video-container">
      <iframe width="100%" height="auto" src="https://www.youtube.com/embed/Af9L66QtmxI" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="commanditaires">
      <h2 style="font-weight: 600; text-align: left; font-family: Lato;">{{ $t('commanditaires') }}</h2>

      <div class="rangee-image" style="margin-top: 50px;">
        <div class="conteneur-image"><img class="commanditaire" src="../assets/img/UL_PNG-e1662480636746.webp" alt="UL" /></div>
        <div class="conteneur-image"><img class="commanditaire" src="../assets/img/Logo-SoftdB-pantone-color.png" alt="SoftdB" /></div>
        <div class="conteneur-image"><img class="commanditaire" src="../assets/img/AESGULfinalCOULEUR.png" alt="AESGUL" /></div>
      </div>

      <div class="rangee-image" style="margin-top: 50px;">
        <div class="conteneur-image"><img class="commanditaire" src="../assets/img/ABB_PNG-300x115.webp" alt="ABB" /></div>
        <div class="conteneur-image"><img class="commanditaire" src="../assets/img/Morneau_noir_logo2022.png" alt="Morneau" /></div>
        <div class="conteneur-image"><img class="commanditaire" src="../assets/img/Maplesoft_logo_Cybernet.svg" alt="Maple" /></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  // eslint-disable-next-line
  name : "Home",
  data () {
    return {
      targetDate: new Date(new Date().getFullYear() + 0, 5, 19, 0, 0, 0), // June 19th 2024
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
    };
  },
  mounted() {
    this.updateCountdown();
    setInterval(this.updateCountdown, 1000);
  },
  methods: {
    updateCountdown() {
      const now = new Date();
      const timeDifference = this.targetDate - now;
      if (timeDifference <= 0) {
        // Countdown is over
        this.days = '00';
        this.hours = '00';
        this.minutes = '00';
        this.seconds = '00';
      } else {
        // Calculate days, hours, minutes, and seconds
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        // Update the data properties
        this.days = this.formatNumber(days);
        this.hours = this.formatNumber(hours);
        this.minutes = this.formatNumber(minutes);
        this.seconds = this.formatNumber(seconds);
      }
    },
    formatNumber(number) {
      return number.toString().padStart(2, '0');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  width : auto;
  text-align: center;
  font-size : 2.5em;
  margin-bottom: 70px; 
}
h3 {
  margin: 40px 0 0;
}
a {
  color: #5fbf00;
}

.contenu {
  width: 100%;
  margin-top : 75px;
}


.location{
  width: 75%;
  margin: 25px 0 0 0;
  font-size : 1.30em;
  font-family: Lato;
  display : inline-block;
  align-items : center;
  text-align : left;
}

.infos{
  margin: 25px 0 0 5%;
  text-align : left;
}

.titre{
  font-family: Rubik bold;
  letter-spacing: 0.1em;
  color: #193300; 
}

.fond{
  width: 50%;
  max-width: 100%;
  margin-top: 30px;
}
.countdown {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  margin-top: 25px;
}

.countdown-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20px;
}

.countdown-item span {
  font-size: 36px;
}

.temps{
  margin: 15px 0 0 0;
}
.message {
  width : 75%;
  display : inline-block;
  align-items : center;
  text-align : left;
  font-size : 1.25em;
  font-family: Lato;
  margin-top: 55px;
}
.timeline{
  margin: 75px auto;
  width: 75%;
}

.video-container {
  position: relative;
  margin: 55px auto;
  width: 50%;
  padding-bottom: 28.25%; /* 16:9 aspect ratio */
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.commanditaires{
  width: 75%;
  margin: 100px auto;
}

.rangee-image {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  align-items: center;
}

.conteneur-image {
  width: 20%;
  text-align: center;
}

.conteneur-image-duo {
  width: 22%;
  text-align: center;
}

.commanditaire {
  max-width: 100%;
  height: auto;
}
</style>
